var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"year-badge",class:`collections-${_vm.theme}-common-hexagon`},[_c('YearIcon',{staticClass:"icon",attrs:{"year":_vm.collection ? _vm.collection.year : null}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }